import { FilterConfig } from "../../../components/Tables/advancedRecord/FilterBar";

/**
 * Construye la configuración de filtros para la consulta de Ajustes de Inventario.
 */
export const buildInventoryAdjustmentFilters = (
  branchDropdown: { id: number; name: string }[],
  productDropdown: { id: number; name: string }[],
  adjustmentTypeOptions: { id: string; name: string }[]
): FilterConfig[] => [
  {
    name: "branchId",
    label: "Sucursal",
    type: "searchSelect",
    options: branchDropdown.map((b) => ({
      id: b.id,
      name: b.name,
    })),
    colSpan: 3,
  },

  {
    name: "productId",
    label: "Producto",
    type: "searchSelect",
    options: productDropdown.map((p) => ({
      id: p.id,
      name: p.name,
    })),
    colSpan: 4,
  },

  {
    name: "adjustmentType",
    label: "Tipo de Ajuste",
    type: "select",
    options: adjustmentTypeOptions,
    colSpan: 2,
  },

  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    colSpan: 3,
  },

  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    colSpan: 3,
  },
];